// Generated by BUCKLESCRIPT VERSION 5.0.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/src/Css.js");

Css.$$global("html, body, h1, h2, h3", /* :: */[
      Css.margin(/* zero */-789508312),
      /* :: */[
        Css.padding(/* zero */-789508312),
        /* [] */0
      ]
    ]);

Css.$$global("h1, h2, h3", /* :: */[
      Css.fontSize(Css.pct(100)),
      /* :: */[
        Css.fontWeight(/* normal */812216871),
        /* [] */0
      ]
    ]);

Css.$$global("button", /* :: */[
      Css.margin(/* zero */-789508312),
      /* [] */0
    ]);

Css.$$global("html", /* :: */[
      Css.boxSizing(/* inherit_ */-601204732),
      /* [] */0
    ]);

Css.$$global("*, *:after, *:before", /* :: */[
      Css.boxSizing(/* borderBox */9307263),
      /* [] */0
    ]);

Css.$$global(":root", /* :: */[
      Css.fontSize(Css.em(0.75)),
      /* :: */[
        Css.media("(min-width: 25em) and (max-width: 93.75em)", /* :: */[
              Css.unsafe("fontSize", "calc(.75em + (18 - 12) * ((100vw - 25em) / (1500 - 400)))"),
              /* [] */0
            ]),
        /* :: */[
          Css.media("(min-width: 93.75em)", /* :: */[
                Css.fontSize(Css.em(1.125)),
                /* [] */0
              ]),
          /* [] */0
        ]
      ]
    ]);

Css.$$global("html", /* :: */[
      Css.lineHeight(/* `abs */[
            4845682,
            1.45
          ]),
      /* :: */[
        Css.unsafe("MozOsxFontSmoothing", "grayscale"),
        /* :: */[
          Css.unsafe("WebkitFontSmoothing", "antialiased"),
          /* :: */[
            Css.overflowX(Css.hidden),
            /* :: */[
              Css.unsafe("textRendering", "optimizeLegibility"),
              /* [] */0
            ]
          ]
        ]
      ]
    ]);

Css.$$global("body", /* :: */[
      Css.background(Css.hex("efefef")),
      /* :: */[
        Css.color(Css.hex("838383")),
        /* :: */[
          Css.display(/* flex */-1010954439),
          /* :: */[
            Css.fontFamily(/* array */[
                    "-apple-system",
                    "BlinkMacSystemFont",
                    "'Segoe UI'",
                    "Roboto",
                    "Helvetica",
                    "Arial",
                    "sans-serif",
                    "'Apple Color Emoji'",
                    "'Segoe UI Emoji'",
                    "'Segoe UI Symbol'"
                  ].join(", ")),
            /* :: */[
              Css.height(/* `calc */[
                    -1044768619,
                    /* tuple */[
                      /* sub */5745024,
                      Css.vh(100),
                      Css.em(3)
                    ]
                  ]),
              /* :: */[
                Css.justifyContent(/* center */98248149),
                /* :: */[
                  Css.marginTop(Css.em(3)),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

/*  Not a pure module */
